import { createIcon } from '@chakra-ui/icons';

export const Cog = createIcon({
  displayName: 'Cog',
  viewBox: '0 0 15 15',
  path: [
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_871_668)">
        <path
          d="M7.5 9.375C8.53553 9.375 9.375 8.53553 9.375 7.5C9.375 6.46447 8.53553 5.625 7.5 5.625C6.46447 5.625 5.625 6.46447 5.625 7.5C5.625 8.53553 6.46447 9.375 7.5 9.375Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M12.5001 7.5C12.4994 7.13995 12.46 6.78102 12.3826 6.42937L14.0789 5.145L12.8289 2.98L10.8645 3.80875C10.3326 3.32106 9.70117 2.95452 9.01389 2.73438L8.75014 0.625H6.25014L5.98639 2.73438C5.2991 2.95452 4.66772 3.32106 4.13576 3.80875L2.17139 2.98L0.921387 5.145L2.61764 6.42937C2.46101 7.13453 2.46101 7.86547 2.61764 8.57063L0.921387 9.855L2.17139 12.02L4.13576 11.1913C4.66772 11.6789 5.2991 12.0455 5.98639 12.2656L6.25014 14.375H8.75014L9.01389 12.2656C9.70117 12.0455 10.3326 11.6789 10.8645 11.1913L12.8289 12.02L14.0789 9.855L12.3826 8.57063C12.46 8.21898 12.4994 7.86005 12.5001 7.5Z"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_871_668">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
